import React from "react";
import Marty from "marty";
import Hero from "../components/Hero";
import { Modal } from "react-bootstrap";
import assign from "object-assign";
import Embed from "../components/FluidEmbed";
import ImageSlideshow from "../../../components/ImageSlideshow";
import PressCarousel from "./components/PressCarousel";
import BuyButton from "../../../components/BuyButton";
import PAE from "../components/PositionAwareElement";
import Swipe from "react-swipe";
import Pulse from "./components/Pulse";

let pressData = [
    {
        quote: "Struggle with WiFi speeds and coverage in your home? eero has the answer.",
        name: "Jason Cipriani",
        company: "Fortune",
        link: "http://fortune.com/2016/02/23/eero-home-networking-review/",
        logo: "eo-icon-fortune",
        color: "#00457C"
    },
    {
        quote: "The eeros have worked perfectly, which is no small thing, because my home has a couple of quirks that make WiFi tough.",
        name: "Walt Mossberg",
        company: "The Verge",
        link: "http://www.theverge.com/2016/2/23/11095610/eero-review-wi-fi-router-walt-mossberg",
        logo: "eo-icon-verge",
        color: "#FA4B2A"
    },
    {
        quote: "eero one-ups traditional routers in the two areas that matter to most of us: total coverage and simplicity.",
        name: "Geoff Fowler",
        company: "Wall Street Journal",
        link: "http://www.wsj.com/articles/review-the-end-of-bad-home-wi-fi-1456236474",
        logo: "eo-icon-wall-street-journal",
        color: "black"
    },
    {
        quote: "eero is the home WiFi solution I’ve been waiting for.",
        name: "Nicole Lee",
        company: "Engadget",
        link: "http://www.engadget.com/2016/02/23/eero-is-the-home-wifi-solution-ive-been-waiting-for/",
        logo: "eo-icon-engadget",
        color: "#03AEDA"
    },
    {
        quote: "The eeros consistently covered my house with faster download speeds and a better signal.",
        name: "Nathan McAlone",
        company: "Business Insider",
        link: "http://www.businessinsider.com/eero-wifi-router-review-2016-2",
        logo: "eo-icon-business-insider",
        color: "#185F7D"
    },
    {
        quote: "It was easier to set up than the iPhone I was tapping on.",
        name: "Mike Murphy",
        company: "Quartz",
        link: "http://qz.com/622000/theres-a-frustration-free-wifi-router-that-you-can-actually-set-up-in-less-than-five-minutes",
        logo: "eo-icon-quartz",
        color: "black"
    }
];

let pressCarouselInterval = 4000;

let slideUrls = [
    "hero-bg-root-1.jpg",
    "hero-bg-root-2.jpg",
    "hero-bg-root-3.jpg",
    "hero-bg-root-4.jpg"
].map(file => `/public/img/root/heros/${file}`);

let screenshots = [
    "/public/img/root/screens/0.png",
    "/public/img/root/screens/1.png",
    "/public/img/root/screens/2.png",
    "/public/img/root/screens/3.png",
    "/public/img/root/screens/4.png",
    "/public/img/root/screens/5.png"
];

let Root = React.createClass({
    getInitialState() {
        return {
            showModal: {
                video: false
            },
            carouselIndex: 0,
            showScreenshots: false
        };
    },
    componentWillMount() {
        if (Marty.isBrowser) {
            document.title = "eero - Finally, WiFi that works";
        }
    },
    mailingList() {
        this.app.navStore.showMailingListModal();
    },
    handleSlideshowChange(vis, vPos, hPos, state) {
        if ((state.visible && (state.middleVThird || state.topThird)) && !this.state.showScreenshots) {
            this.setState({showScreenshots: true});
        }
    },
    closeModal(modal) {
        if (this.state.showModal[modal] === undefined) {
            return;
        }
        this.setState({
            showModal: assign({},
                this.state.showModal,
                {[modal]: false}
            )
        });
    },
    carouselCallback(i) {
        this.setState({carouselIndex: i});
    },
    openModal(modal) {
        if (this.state.showModal[modal] === undefined) {
            return;
        }
        this.setState({
            showModal: assign({},
                this.state.showModal,
                {[modal]: true}
            )
        });
    },
    render() {
        return (
            <section className="eo-view root grid-10 parent no-gutter">
                <Hero>
                    <ImageSlideshow className="hero-slideshow" urls={slideUrls} interval={5000}/>
                    <div className="eo-hero-overlay"></div>
                    <div className="eo-hero-main-content">
                        <h1>The world’s best-reviewed<br />WiFi system</h1>
                        <button className="btn-play"
                                onClick={this.openModal.bind(this, "video")}>
                            <span className="btn-play-text">PLAY<br/>VIDEO</span>
                            <span className="btn-play-icon icon eo-icon-play"/>
                        </button>
                        <Modal dialogClassName="eo-modal video-modal" show={this.state.showModal.video}
                               onHide={this.closeModal.bind(this, "video")}>
                            <Modal.Header closeButton/>
                            <Modal.Body>
                                <Embed src="https://www.youtube.com/embed/tOcvNoEOyMQ"/>
                            </Modal.Body>
                        </Modal>
                    </div>
                </Hero>

                <div className="eo-padded-wrapper">

                    {/* WORLDS FIRST */}
                    <section className="worlds-first grid-10 eo-section eo-info-panel dark centered">
                        <h2 className="standard">No more buffering. No more dead zones.</h2>
                        <p className="standard">eero is the world’s first home WiFi system, powered by TrueMesh™. A set of three eeros covers the typical home. They work in perfect unison to deliver
                            hyper-fast, super-stable WiFi to every square foot of your house. It’s simple to set up. Easy to manage. And gets better over time with new features and
                            improved performance. Stream video, get work done, or swipe right in any room — not just next to your router. Finally. WiFi that <em>actually</em> works.</p>
                    </section>

                    {/* PRESS CAROUSEL */}
                    <PressCarousel data={pressData} visibleSlides={5} autoPlay={pressCarouselInterval}/>

                    {/* ONE ROUTER MODEL */}
                    <section className="one-router-model grid-10 eo-section eo-info-panel centered">
                        <div className="copy-left grid-5 grid-s-10">
                            <h2 className="standard">The one-router<br/>model isn&rsquo;t working</h2>
                            <p className="standard">Relying on a single router is like asking a loud speaker in your living room to provide great sound throughout your home. It’s simple physics: WiFi
                                waves don’t go through walls well and have an even harder time climbing stairs. Ever tried to stream a show from your bedroom when your router’s in the office
                                downstairs? It’s a buffering nightmare.</p>

                            <p className="standard">To solve this, you need multiple access points — devices that broadcast WiFi — distributed throughout your home. That’s what you’ll find in office
                                buildings, both big and small. But these solutions are out of reach for most of us, and all we’re left with is a band-aid solution: range “extenders,” which don’t live
                                up to their name.</p>
                        </div>
                        <div className="grid-5 grid-s-10 img-right">
                            <PAE className="floor top animated">
                                <img className="floor-img" src="/public/img/root/two-story-traditional.png"/>
                                <Pulse className="pulse-1 red"/>
                            </PAE>
                            <img className="floor static" src="/public/img/root/pulse-static-1.png"/>

                        </div>
                    </section>

                    {/* MAGIC IN THE SYSTEM */}
                    <section className="magic-in-system grid-10 eo-section eo-info-panel centered">
                        <div className="divider"></div>
                        <div className="copy-left grid-5 grid-s-10 push-m-5 push-l-5 push-xl-5 parent">
                            <h2 className="standard">It takes a system</h2>
                            <p className="standard">With eero, you simply plug one device into your modem. Additional eeros simply need power from a standard outlet. They automatically connect to each
                                other to create a single wireless mesh network that covers your whole home. If you already have Ethernet wiring, you can always choose to hardwire your additional
                                eeros.
                            </p>

                            <p className="standard">Three eeros cover the typical home. You can start with one and eero-up depending on the size of your space. With cutting-edge TrueMesh technology, add as many as you need and eero will intelligently adapt to your home. You already pay for high-speed Internet
                                — isn’t it time to get what you’ve paid for in every corner of every room?
                            </p>
                        </div>
                        <div className="grid-5 grid-s-10 pull-m-5 pull-l-5 pull-xl-5 img-left">
                            <PAE className="floor animated">
                                <img className="floor-img" src="/public/img/root/two-story-eero.png"/>
                                <Pulse className="pulse-1"/>
                                <Pulse className="pulse-2"/>
                                <Pulse className="pulse-3"/>
                            </PAE>
                            <img className="floor static" src="/public/img/root/pulse-static-3.png"/>
                        </div>
                    </section>

                    <section className="grid-10 eo-section eo-info-panel centered three-eeros">
                        <img className="img-phone eo-img-fluid" src="/public/img/root/three-eeros.png"/>
                        <PAE className="led-wrap">
                            <img className="img-phone-led eo-img-fluid" src="/public/img/root/three-eeros-led.png"/>
                        </PAE>
                    </section>

                    {/* FEATURES */}
                    <section className="features eo-section grid-10 eo-info">
                        <h2 className="standard">Quick look</h2>
                        <Swipe slideToIndex={this.state.carouselIndex} className="carousel" callback={this.carouselCallback}>

                            {/* FEATURES - MOBILE */}
                            <div className="eo-data">
                                <span className="icon eo-icon-stopwatch"></span>
                                <h3>Simple setup</h3>
                                <p className="standard">Plug one eero into your modem and the app will help you strategically place the others throughout your home. You can name your network anything
                                    you want. <em>Anything.</em></p>
                            </div>

                            <div className="eo-data">
                                <span className="icon eo-icon-shield-check"></span>
                                <h3>Security that’s one step ahead</h3>
                                <p className="standard">eero automatically downloads the latest security updates to keep your network secure. You don’t need to lift a finger.</p>
                            </div>

                            <div className="eo-data">
                                <span className="icon eo-icon-share"></span>
                                <h3>Feel free to overshare</h3>
                                <p className="standard">Easily grant access to friends and family or share a separate guest network with them. No need to dig through the kitchen drawer for your WiFi
                                    password.</p>
                            </div>

                            <div className="eo-data">
                                <span className="eo-icon-wifi-home icon"></span>
                                <h3>Stays new, gets better</h3>
                                <p className="standard">Automatic software updates that bring new features happen overnight and only take a minute. That means your eero system gets better with
                                    time.</p>
                            </div>

                            <div className="eo-data">
                                <span className="eo-icon-phone icon"></span>
                                <h3>WiFi in the palm of your hand</h3>
                                <p className="standard">Manage your entire WiFi network from a simple, intuitive app. See which devices are connected and the speeds you’re clocking.</p>
                            </div>

                            <div className="eo-data">
                                <span className="eo-icon-family icon"></span>
                                <h3>Manage screen time</h3>
                                <p className="standard">With just a few taps you can create Family Profiles, manage schedules for internet access, or pause the internet.</p>
                            </div>

                        </Swipe>
                        <div className="carousel-dots">
                            {[0, 1, 2, 3, 4, 5].map(i => <span key={i} onClick={this.carouselCallback.bind(null, i)}
                                                               className={["carousel-dot", (i === this.state.carouselIndex ? "active" : "")].join(" ")}/>)}
                        </div>

                        {/* FEATURES - DESKTOP */}
                        <div className="eo-text-group grid-10 parent hide-s">
                            <div className="parent grid-s-10 grid-4 push-m-3 push-xl-3 push-l-3">
                                { this.state.showScreenshots ?
                                    <div className="screen-slideshow-wrap"><ImageSlideshow className="screen-slideshow quick" urls={screenshots} interval={5000}/></div> : null }
                                <PAE onChange={this.handleSlideshowChange}><img className="img-phone eo-img-fluid" src="/public/img/root/img-features-dashboard.png"/></PAE>
                            </div>

                            {/* RIGHT SIDE */}
                            <div className="grid-s-10 grid-3 pull-m-4 pull-xl-4 pull-l-4 feature-group">
                                <div className="eo-data right">
                                    <span className="icon eo-icon-stopwatch"></span>
                                    <h3>Simple setup</h3>
                                    <p>Plug one eero into your modem and the app will help you place the others throughout your home. You can name your network anything you want. <em>Anything.</em>
                                    </p>
                                </div>

                                <div className="eo-data right">
                                    <span className="icon eo-icon-shield-check"></span>
                                    <h3>Security that’s one step ahead</h3>
                                    <p>eero automatically downloads the latest security updates to keep your network secure. You don’t need to lift a finger.</p>
                                </div>

                                <div className="eo-data right">
                                    <span className="icon eo-icon-share"></span>
                                    <h3>Feel free to overshare</h3>
                                    <p>Easily grant access to friends and family or share a separate guest network with them. No need to dig through the kitchen drawer for your WiFi password.</p>
                                </div>
                            </div>

                            {/* LEFT SIDE */}
                            <div className="grid-s-10 grid-3 feature-group">
                                <div className="eo-data left">
                                    <span className="eo-icon-wifi-home icon"></span>
                                    <h3 className="eo-data-title bold">Stays new, gets better</h3>
                                    <p>Automatic software updates that bring new features happen overnight and only take a minute. That means your eero system gets better with time.</p>
                                </div>

                                <div className="eo-data left">
                                    <span className="eo-icon-phone icon"></span>
                                    <h3>WiFi in the palm of your hand</h3>
                                    <p>Manage your entire WiFi network from a simple, intuitive app. See which devices are connected and the speeds you’re clocking.</p>
                                </div>

                                <div className="eo-data left">
                                    <span className="eo-icon-family icon"></span>
                                    <h3>Manage screen time</h3>
                                    <p>With just a few taps you can create Family Profiles, manage schedules for internet access, or pause the internet.</p>
                                </div>
                            </div>
                        </div>
                    </section>
                    <section className="grid-10 eo-section eo-cta wfb hide-s">
                        <div className="eo-cta-content">
                            <h3 className="eo-cta-header"><span className="big-text eo-cta-header-group">WFB</span><span className="eo-cta-header-group">WORK FROM<br/>BACKYARD</span></h3>
                            <BuyButton/>
                        </div>
                    </section>
                </div>
            </section>
        );
    }
});

export default Marty.createContainer(Root, {});



/** WEBPACK FOOTER **
 ** ./app/views/anonymous/views/root/Handler.js
 **/